import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';

/**
 * The single gate for booking retention (CCPE-2665): the retention release
 * flag alone. Independent of featureEnableAgentInboxForCalls. Lives outside
 * InboxModule so the Inbox state can read it without importing the module.
 */
export const isBookingRetentionEnabled = (): boolean =>
  FeatureFlagModule.isEnabled(FeatureFlagKeys.featureRetainEndedCallCards);
